import { Box, Grid } from "@mui/material"




export const LineaSeparadora = ({ padding=0, bottom=3, top=2 }) => {

    return (

        <Grid item xs={12}  px={padding}>
            <Box sx={{ mb:bottom, mt:top, height:"1.3px", background:"#8B8B8B", width:"100%"}} />
        </Grid>

    )
}
